export default {
    unittype_event_create_success_message: "The event has been created",
    unittype_event_create_title: "Create Unit Type Event",
    unittype_event_edit_success_message: "The event has been edited",
    unittype_event_edit_title: "Edit Unit Type Event",
    unittype_event_name: "Name",
    unittype_event_status: "Status",
    unittype_event_active: "Active",
    unittype_event_inactive: "Inactive",
    unittype_event_diagnostic: "Diagnostic",
    unittype_event_tab_general: "General",
    unittype_event_tab_unit_type_event: "Unit Type Event",
    unittype_event_manufacturer: "Manufacturer",
    unittype_event_unit_type: "Unit Type",
    unittype_event_event: "Event",
    unittype_event_raw_event: "Raw Event",
    unittype_event_already_exists: "The unit type event already exists for this unit type",

}